import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../Environment/environment';
@Component({
  selector: 'app-fandialog',
  templateUrl: './fandialog.component.html',
  styleUrl: './fandialog.component.css'
})
export class FandialogComponent {
  constructor(public dialogRef: MatDialogRef<FandialogComponent>,public dialog: MatDialog) {
    this.AssetbasePath = environment.assetsPath;
  }
  AssetbasePath:any;
  selectImage(imageName: string) {
    this.dialogRef.close(imageName); // Close the dialog and pass the selected image name
  }
  closePopup(){
    this.dialog.closeAll()
    }
}
